(() => {
  'use strict';
  const formatReviewDate = value => {
    if (typeof value !== 'string') return null;
    const parts = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2})(\.\d{1,9})?)?(?:\s*(Z|UTC|[+-]\d{2}:?\d{2}))?)?$/i);
    if (!parts) return null;
    const year = Number(parts[1]), month = Number(parts[2]), day = Number(parts[3]);
    const hour = Number(parts[4] || 0), minute = Number(parts[5] || 0), second = Number(parts[6] || 0);
    if (month < 1 || month > 12 || day < 1 || day > 31 || hour > 23 || minute > 59 || second > 59) return null;
    const calendar = new Date(0);
    calendar.setUTCFullYear(year, month - 1, day);
    if (calendar.getUTCFullYear() !== year || calendar.getUTCMonth() !== month - 1 || calendar.getUTCDate() !== day) return null;
    let zone = (parts[8] || 'Z').toUpperCase();
    if (zone === 'UTC') zone = 'Z';
    if (zone !== 'Z') {
      zone = zone.replace(/([+-]\d{2})(\d{2})$/, '$1:$2');
      if (Number(zone.slice(1, 3)) > 23 || Number(zone.slice(4, 6)) > 59) return null;
    }
    const fraction = parts[7] ? `.${parts[7].slice(1).padEnd(3, '0').slice(0, 3)}` : '';
    const iso = `${parts[1]}-${parts[2]}-${parts[3]}T${parts[4] || '00'}:${parts[5] || '00'}:${parts[6] || '00'}${fraction}${zone}`;
    const date = new Date(iso);
    return Number.isFinite(date.getTime()) ? new Intl.DateTimeFormat(document.documentElement.lang || 'en', {month:'short',day:'numeric',year:'numeric',timeZone:'UTC'}).format(date) : null;
  };
(() => {
  'use strict';
  // Exact historical-title duplicate verified against the retained Judge.me widget.
  // Match review ID, product path and unedited body; never hide similar customer text.
  const historicalTitleDuplicates = {
    '56c6f449-3aff-4fc5-8f3d-f1189fa63d09': {
      productPath: '/products/new-dad-gifts-leveled-up-to-daddy-mug-first-time-dad-gifts-dad-to-be-gifts',
      body: 'New Dad Gifts: Leveled Up To Daddy Mug | First Time Dad Gifts | Dad To Be Gifts'
    }
  };
  const init = () => document.querySelectorAll('.bp-review-redesign').forEach(hub => {
    if (hub.dataset.bpReviewEnhanced) return;
    hub.dataset.bpReviewEnhanced = 'true';
    const panel = hub.querySelector('#bp-product-reviews');
    const overview = panel && panel.querySelector('[data-bp-review-overview]');
    const widget = panel && panel.querySelector('#judgeme_product_reviews');
    if (!overview || !widget) return;
    const summary = overview.querySelector('[data-bp-product-summary]');
    const empty = overview.querySelector('[data-bp-review-empty]');
    const photoButton = overview.querySelector('[data-bp-photo-filter]');
    const allButton = overview.querySelector('[data-bp-all-reviews]');
    const rail = overview.querySelector('[data-bp-photo-rail]');
    let signature = '', queued = false;
    const refresh = () => {
      queued = false;
      const native = widget.querySelector('.jdgm-rev-widg');
      if (!native) return;
      const count = Number(native.dataset.numberOfReviews), rating = Number(native.dataset.averageRating);
      if (Number.isInteger(count) && count >= 0 && Number.isFinite(rating) && rating >= 0 && rating <= 5 && (count === 0 || rating > 0)) {
        summary.textContent = count ? overview.dataset.summary.replace('__RATING__', String(rating)).replace('__COUNT__', count.toLocaleString(document.documentElement.lang || 'en')) : overview.dataset.empty;
        summary.hidden = false; empty.hidden = count > 0; photoButton.hidden = count === 0;
        overview.querySelector('.bp-buyer-photo-heading').hidden = count === 0;
        hub.classList.add('is-summary-ready');
      }
      widget.querySelectorAll('.jdgm-rev').forEach(review => {
        const body = review.querySelector('.jdgm-rev__body'), title = review.dataset.productTitle;
        if (body) {
          const historical = historicalTitleDuplicates[review.dataset.reviewId];
          const exactHistorical = historical && review.dataset.productUrl === historical.productPath && body.textContent.trim() === historical.body;
          body.classList.toggle('bp-review-redundant-title', Boolean((title && body.textContent.trim() === title.trim()) || exactHistorical));
        }
        const time = review.querySelector('time[datetime]');
        if (time) {
          const label = formatReviewDate(time.getAttribute('datetime'));
          if (label !== null && time.textContent !== label) time.textContent = label;
        }
      });
      const select = widget.querySelector('.jdgm-sort-dropdown');
      const filtering = select && select.value === 'with-pictures';
      photoButton.setAttribute('aria-pressed', String(Boolean(filtering))); allButton.hidden = !filtering;
      const photos = [...widget.querySelectorAll('.jdgm-rev__pics .jdgm-rev__pic-link')].filter(link => link.querySelector('img') && /^https?:/.test(link.href));
      const nextSignature = photos.map(link => link.href).join('|');
      if (nextSignature !== signature) {
        signature = nextSignature;
        const fragment = document.createDocumentFragment();
        photos.slice(0,12).forEach(link => {
          const source = link.querySelector('img');
          const author = link.closest('.jdgm-rev')?.querySelector('.jdgm-rev__author')?.textContent.trim() || '';
          const anchor = document.createElement('a'); anchor.href = link.href; anchor.target = '_blank'; anchor.rel = 'noopener';
          const image = document.createElement('img'); image.src = source.currentSrc || source.src || source.dataset.src; image.alt = overview.dataset.photoAlt.replace('__AUTHOR__', author); image.loading = 'lazy'; image.width = 160; image.height = 160;
          anchor.append(image); anchor.addEventListener('click', event => { if (link.isConnected) { event.preventDefault(); link.click(); } }); fragment.append(anchor);
        });
        rail.replaceChildren(fragment); rail.hidden = photos.length === 0;
      }
    };
    const setFilter = value => {
      const select = widget.querySelector('.jdgm-sort-dropdown');
      if (!select || ![...select.options].some(option => option.value === value)) return;
      if (select.value !== value) { select.value = value; select.dispatchEvent(new Event('change', {bubbles: true})); }
      refresh();
    };
    photoButton.addEventListener('click', () => setFilter('with-pictures'));
    allButton.addEventListener('click', () => setFilter('most-recent'));
    overview.querySelector('[data-bp-open-shop]').addEventListener('click', () => hub.querySelector('[data-review-target="bp-store-reviews"]')?.click());
    widget.addEventListener('change', refresh);
    new MutationObserver(() => { if (!queued) { queued = true; requestAnimationFrame(refresh); } }).observe(widget, {childList: true, subtree: true, attributes: true, attributeFilter: ['data-average-rating','data-number-of-reviews','src','datetime']});
    refresh();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();

/* Etsy-inspired presentation. Native review data and archive remain the source of truth. */
(() => {
  'use strict';
  const init = () => document.querySelectorAll('.bp-review-redesign').forEach(hub => {
    if (hub.dataset.bpEtsyLayout || typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
    const panel = hub.querySelector('#bp-product-reviews');
    const overview = panel?.querySelector('[data-bp-review-overview]');
    const widget = panel?.querySelector('#judgeme_product_reviews');
    const shopPanel = hub.querySelector('#bp-store-reviews');
    const shop = hub.nextElementSibling?.matches('.bp-shop-confidence') ? hub.nextElementSibling : null;
    const archive = shopPanel?.querySelector('[data-bp-etsy]');
    if (!overview || !widget || !shopPanel || !shop || !archive) return;
    const nativeReady = () => Boolean(widget.querySelector('.jdgm-rev') || widget.querySelector('.jdgm-rev-widg[data-number-of-reviews="0"]'));
    if (!nativeReady()) {
      if (!hub.dataset.bpEtsyLayoutPending) {
        hub.dataset.bpEtsyLayoutPending = 'true';
        const readyObserver = new MutationObserver(() => {
          if (!nativeReady()) return;
          readyObserver.disconnect();delete hub.dataset.bpEtsyLayoutPending;
          requestAnimationFrame(init);
        });
        readyObserver.observe(widget,{subtree:true,childList:true,attributes:true,attributeFilter:['data-number-of-reviews']});
      }
      return;
    }
    hub.dataset.bpEtsyLayout = 'true';
    const make = (tag, className, text) => {const el = document.createElement(tag);if (className) el.className = className;if (text !== undefined) el.textContent = text;return el;};
    const button = (text, className = 'bp-etsy-outline') => {const el = make('button', className, text);el.type = 'button';return el;};
    const summary = overview.querySelector('[data-bp-product-summary]');
    const empty = overview.querySelector('[data-bp-review-empty]');
    const photosHeading = overview.querySelector('.bp-buyer-photo-heading');
    const photoButton = overview.querySelector('[data-bp-photo-filter]');
    const oldRail = overview.querySelector('[data-bp-photo-rail]');
    const allButton = overview.querySelector('[data-bp-all-reviews]');
    const compactTitleDuplicates = {
      'da85cf5b-2f9f-4101-aebf-d547987cbd5a': {
        productPath: '/products/customized-mom-gifts-i-love-you-more-the-end-i-win-love-personalized-name-mothers-day-gift-for-mom-coffee-mug-tea-cup',
        body: "Customized Mom Gifts I Love You More The End I Win Love Personalized Name Mother's Day Gift for Mom Coffee Mug Tea Cup"
      },
      '784bf49b-ac97-4fee-8326-69d8274cad00': {
        productPath: '/products/customized-mom-gifts-i-love-you-more-the-end-i-win-love-personalized-name-mothers-day-gift-for-mom-coffee-mug-tea-cup',
        body: "Customized Mom Gifts I Love You More The End I Win Love Personalized Name Mother's Day Gift for Mom Coffee Mug Tea Cup"
      }
    };
    const isCompactTitleDuplicate = (review, body) => {
      const match = compactTitleDuplicates[review.dataset.reviewId];
      return Boolean(match && review.dataset.productUrl === match.productPath && body.textContent.trim() === match.body);
    };
    const preview = make('div','bp-etsy-item-preview');
    preview.setAttribute('aria-label','Recent reviews for this item');
    const actions = make('div','bp-etsy-preview-actions');
    const why = make('details','bp-etsy-why');
    why.append(make('summary','', 'Why these reviews?'),make('p','', 'These reviews belong to this item in our review system. Original ratings and feedback are preserved. Etsy shop reviews are shown separately and do not count toward this item’s rating.'));
    const viewAll = button('View all reviews for this item');
    const writeReview = button('Write a review');
    actions.append(why,viewAll,writeReview);
    overview.insertBefore(preview,photosHeading);
    overview.insertBefore(actions,photosHeading);
    photosHeading.querySelector('h3').textContent = 'Photos from reviews';
    photoButton.textContent = 'View photos';
    const photoRail = make('div','bp-etsy-photos');photoRail.hidden = true;
    oldRail.after(photoRail);
    const openDialogs = new Set();let originalOverflow = '';
    const modal = (name, key) => {
      const dialog = make('dialog','bp-etsy-dialog');dialog.id = 'bp-' + key + '-dialog';
      const heading = make('h2','bp-etsy-dialog-heading',name);heading.id = dialog.id + '-title';
      dialog.setAttribute('aria-labelledby',heading.id);
      const close = button('×','bp-etsy-dialog-close');close.setAttribute('aria-label','Close ' + name.toLowerCase());
      const header = make('div','bp-etsy-dialog-header');header.append(heading,close);
      const content = make('div','bp-etsy-dialog-content');dialog.append(header,content);hub.append(dialog);
      let returnFocus = null;
      const hide = () => {if (dialog.open) dialog.close();};
      close.addEventListener('click',hide);
      dialog.addEventListener('cancel',event => {event.preventDefault();hide();});
      dialog.addEventListener('click',event => {if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)hide();});
      dialog.addEventListener('close',() => {openDialogs.delete(dialog);if (!openDialogs.size) document.body.style.overflow = originalOverflow;if(returnFocus?.isConnected)returnFocus.focus({preventScroll:true});});
      return {dialog,content,heading,open(trigger){if(dialog.open)return;returnFocus=trigger||document.activeElement;if(!openDialogs.size)originalOverflow=document.body.style.overflow;openDialogs.add(dialog);document.body.style.overflow='hidden';dialog.showModal();close.focus({preventScroll:true});},close:hide};
    };
    const itemModal = modal('Reviews for this item','item-reviews');
    const modalSummary = make('p','bp-review-simple-summary');itemModal.content.append(modalSummary,allButton,widget);
    const shopModal = modal('Reviews for this shop','shop-reviews');shopModal.content.append(shopPanel);
    const photoModal = modal('Photo from a review','review-photo');
    const largePhoto = make('img','bp-etsy-large-photo');const caption = make('p','bp-etsy-photo-caption');photoModal.content.append(largePhoto,caption);
    const openPhoto = (url,alt,trigger) => {largePhoto.src=url;largePhoto.alt=alt;caption.textContent=alt;photoModal.open(trigger);};
    widget.addEventListener('click',event => {const link=event.target.closest?.('.jdgm-rev__pic-link');if(!link || !/^https?:/.test(link.href))return;event.preventDefault();event.stopImmediatePropagation();const name=link.closest('.jdgm-rev')?.querySelector('.jdgm-rev__author')?.textContent.trim()||'';openPhoto(link.href,name?'Review photo from '+name:'Photo from a review',link);},true);
    const readOther = overview.querySelector('[data-bp-open-shop]');
    readOther.textContent = 'Read reviews for other items';
    // Remove the previous tab-switch listener by replacing this button only.
    const otherLink = readOther.cloneNode(true);readOther.replaceWith(otherLink);
    const shopPreview = make('section','bp-etsy-shop-preview');
    const shopTop = make('div','bp-etsy-shop-preview-heading');
    const showShop = button('Show all');shopTop.append(make('h3','', 'All reviews from this shop'),showShop);
    const shopSource = make('p','bp-etsy-shop-source',archive.querySelector('.bp-etsy-summary')?.textContent.trim()||'Etsy shop reviews');
    const shopCards = make('div','bp-etsy-shop-cards');
    const shopStatus = make('p','bp-etsy-shop-status','Loading shop reviews…');shopStatus.setAttribute('role','status');
    shopPreview.append(shopTop,shopSource,shopCards,shopStatus);shop.append(shopPreview);
    let shopRequested = false;
    const loadShop = () => {if(shopRequested&&(archive.querySelector('.bp-review-card')||archive.querySelector('[aria-busy="true"]')))return;shopRequested=true;hub.dispatchEvent(new CustomEvent('bp:load-shop-reviews'));};
    const openShop = trigger => {loadShop();shopModal.open(trigger);};
    showShop.addEventListener('click',() => openShop(showShop));otherLink.addEventListener('click',() => openShop(otherLink));
    viewAll.addEventListener('click',() => itemModal.open(viewAll));
    let reviewOpenTimer, reviewOpenSequence = 0, automaticReviewClick = false;
    const stopOpeningReview = () => { reviewOpenSequence++; clearTimeout(reviewOpenTimer); };
    itemModal.dialog.addEventListener('close', stopOpeningReview);
    widget.addEventListener('click', event => {
      if (!automaticReviewClick && event.target.closest?.('.jdgm-write-rev-link')) stopOpeningReview();
    }, true);
    writeReview.addEventListener('click',() => {
      stopOpeningReview();
      itemModal.open(writeReview);
      const sequence = reviewOpenSequence;
      let attempts = 0;
      const openNativeReview = () => {
        if (sequence !== reviewOpenSequence || !itemModal.dialog.open) return;
        const trigger = widget.querySelector('.jdgm-write-rev-link');
        const expanded = trigger?.getAttribute('aria-expanded');
        const form = widget.querySelector('.jdgm-form');
        if (expanded === 'true' || (expanded !== 'false' && form?.getClientRects().length)) { stopOpeningReview(); return; }
        attempts++;
        if (trigger) {
          automaticReviewClick = true;
          try { trigger.click(); } finally { automaticReviewClick = false; }
        }
        if (trigger?.getAttribute('aria-expanded') === 'true') { stopOpeningReview(); return; }
        if (attempts < 13 && sequence === reviewOpenSequence && itemModal.dialog.open) reviewOpenTimer = setTimeout(openNativeReview, 250);
      };
      requestAnimationFrame(openNativeReview);
    });
    // Open first, then allow the existing real-photo filter to run inside the modal.
    photoButton.addEventListener('click',() => itemModal.open(photoButton),true);
    const clearAccessibility = node => {node.removeAttribute('role');node.removeAttribute('aria-labelledby');node.hidden=false;};
    clearAccessibility(panel);clearAccessibility(shopPanel);
    hub.querySelector('.bp-review-tab-buttons').hidden = true;
    hub.classList.add('is-etsy-layout');shop.classList.add('is-etsy-shop');
    let previewSignature='',shopSignature='',queued=false;const photoCache=new Map();
    const failedPhotos = new Set();
    const verifiedPhotoSeeds = {
      '4834377891972': {
        productPath: '/products/customized-mom-gifts-i-love-you-more-the-end-i-win-love-personalized-name-mothers-day-gift-for-mom-coffee-mug-tea-cup',
        reviewId: 'd38ff2f2-6399-4202-92a7-328e455fb5ee',
        author: 'J. C.',
        date: '2021-03-06T00:00:20Z',
        url: 'https://review-images.judgeme.com/backyardpeaks/1614988922__C26A8092-2E2C-4CC0-BBFD-913F429E450C__original.png?quality=80&width=1024',
        src: 'https://review-images.judgeme.com/backyardpeaks/1614988922__C26A8092-2E2C-4CC0-BBFD-913F429E450C__original.png?quality=80&width=160'
      }
    };
    const loadVerifiedPhotos = () => {
      const seed = verifiedPhotoSeeds[widget.dataset.id];
      const count = Number(widget.querySelector('.jdgm-rev-widg')?.dataset.numberOfReviews);
      if (!seed || location.pathname !== seed.productPath || !Number.isInteger(count) || count < 1 || failedPhotos.has(seed.url)) return;
      photoCache.set(seed.url, {url: seed.url, src: seed.src, alt: overview.dataset.photoAlt.replace('__AUTHOR__', seed.author)});
      queue();
    };
    const refresh = () => {
      queued=false;
      const native=widget.querySelector('.jdgm-rev-widg');const raw=native?.getAttribute('data-number-of-reviews');
      const count=raw===null||raw===undefined?NaN:Number(raw);
      if(Number.isInteger(count)&&count>=0){
        hub.querySelector(':scope > h2').textContent=count?'Reviews for this item':'Be the first to review this item';
        itemModal.heading.textContent='Reviews for this item ('+count.toLocaleString(document.documentElement.lang||'en')+')';
        viewAll.hidden=count===0;why.hidden=count===0;actions.hidden=false;preview.hidden=count===0;
      }
      modalSummary.textContent=summary.textContent;
      // Keep the unbiased initial item preview. Filtering/pagination remain fully available in the modal.
      const reviews=[...widget.querySelectorAll('.jdgm-rev')];
      if(!previewSignature&&reviews.length){
        const fragment=document.createDocumentFragment();
        reviews.slice(0,4).forEach(review=>{
          const row=make('article','bp-etsy-review-row');const top=make('div','bp-etsy-review-row-top');
          const rawRating=Number(review.querySelector('.jdgm-rev__rating')?.dataset.score);
          if(Number.isInteger(rawRating)&&rawRating>=1&&rawRating<=5){const stars=make('span','bp-etsy-stars','★'.repeat(rawRating)+'☆'.repeat(5-rawRating));stars.setAttribute('aria-label',rawRating+' out of 5 stars');top.append(stars,make('span','bp-etsy-score',String(rawRating)),make('span','bp-etsy-item-tag','This item'));}
          const meta=make('div','bp-etsy-review-meta');meta.append(make('span','bp-etsy-review-author',review.querySelector('.jdgm-rev__author')?.textContent.trim()||''));
          const sourceTime=review.querySelector('time[datetime]');if(sourceTime){const time=make('time','',formatReviewDate(sourceTime.getAttribute('datetime')) ?? sourceTime.textContent);time.dateTime=sourceTime.dateTime;meta.append(time);}
          top.append(meta);row.append(top);
          const title=review.querySelector('.jdgm-rev__title')?.textContent.trim();if(title)row.append(make('p','bp-etsy-review-title',title));
          const body=review.querySelector('.jdgm-rev__body');if(body&&!body.classList.contains('bp-review-redundant-title')&&!isCompactTitleDuplicate(review,body)&&body.textContent.trim())row.append(make('p','bp-etsy-review-body',body.textContent.trim()));
          fragment.append(row);
        });preview.replaceChildren(fragment);previewSignature=reviews.map(r=>r.dataset.reviewId||r.textContent).join('|');
      }
      [...oldRail.querySelectorAll('a')].forEach(link=>{const img=link.querySelector('img');if(img&&/^https?:/.test(link.href)&&!photoCache.has(link.href)&&!failedPhotos.has(link.href))photoCache.set(link.href,{url:link.href,src:img.currentSrc||img.src,alt:img.alt});});
      if(photoRail.children.length!==Math.min(photoCache.size,8)){
        const fragment=document.createDocumentFragment();[...photoCache.values()].slice(0,8).forEach(photo=>{const thumb=button('','bp-etsy-photo-tile');const img=make('img','');img.src=photo.src;img.alt=photo.alt;img.loading='lazy';img.width=260;img.height=260;img.addEventListener('error',()=>{failedPhotos.add(photo.url);photoCache.delete(photo.url);thumb.remove();photoRail.hidden=!photoRail.children.length;},{once:true});thumb.append(img);thumb.addEventListener('click',()=>openPhoto(photo.url,photo.alt,thumb));fragment.append(thumb);});photoRail.replaceChildren(fragment);photoRail.hidden=photoCache.size===0;
      }
      const cards=[...archive.querySelectorAll('.bp-review-card')];const next=cards.slice(0,3).map(c=>c.textContent).join('|');
      if(next&&next!==shopSignature){shopSignature=next;const fragment=document.createDocumentFragment();cards.slice(0,3).forEach(card=>{const copy=card.cloneNode(true);copy.removeAttribute('id');fragment.append(copy);});shopCards.replaceChildren(fragment);shopStatus.hidden=true;}
      const archiveStatus=archive.querySelector('[data-bp-review-status]')?.textContent||'';
      if(!cards.length&&archiveStatus&&archiveStatus!==archive.dataset.loading){shopStatus.textContent=archiveStatus;shopStatus.hidden=false;}
    };
    const queue=()=>{if(!queued){queued=true;requestAnimationFrame(refresh);}};
    new MutationObserver(queue).observe(widget,{subtree:true,childList:true,attributes:true,attributeFilter:['data-average-rating','data-number-of-reviews']});
    new MutationObserver(queue).observe(oldRail,{subtree:true,childList:true});
    new MutationObserver(queue).observe(archive,{subtree:true,childList:true});
    if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){observer.disconnect();loadShop();}},{rootMargin:'300px'});observer.observe(shopPreview);}else loadShop();
    refresh();
    if ('IntersectionObserver' in window) {
      const photoObserver = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        photoObserver.disconnect();loadVerifiedPhotos();
      }, {rootMargin: '200px'});
      photoObserver.observe(photosHeading);
    } else loadVerifiedPhotos();
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
})();
